export default "__VITE_ASSET__4af8b4d6__"